import { useNavigate, useLocation } from 'react-router-dom';
import { Star } from 'lucide-react';
import { useFavorites } from '../../hooks/useFavorites';
import { findCardByRoute } from '../../config/navigation';

// FavoritesBar — barra scorciatoie persistente, in testa a OGNI pagina (montata
// nel Layout, sticky). Permette di saltare tra le funzioni preferite senza
// tornare alla Hub. Sempre visibile: quando non ci sono preferiti mostra
// l'invito ad aggiungerli con la ★ sulle card. Presentazionale: legge solo il
// set preferiti (localStorage, hook condiviso useFavorites). Nessun dato/logica.
export default function FavoritesBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { favorites } = useFavorites();
  const routes = [...(favorites || [])].filter((r) => findCardByRoute(r));

  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 10,
      display: 'flex', alignItems: 'center', gap: 12,
      // Altezza FISSA: la barra non si adatta al contenuto (né vuota né piena),
      // resta identica su ogni pagina. Riga singola con scorrimento orizzontale.
      height: 52, minHeight: 52, flexShrink: 0, boxSizing: 'border-box',
      padding: '0 24px', background: 'var(--ds-bg)',
      borderBottom: '1px solid var(--ds-border)', overflowX: 'auto', overflowY: 'hidden',
    }}>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12.5, fontWeight: 500, color: 'var(--ds-muted)', flexShrink: 0 }}>
        <Star size={15} strokeWidth={1.8} style={{ color: 'var(--warn, #E8912A)' }} fill="currentColor" />
        Preferiti
      </span>

      {routes.length === 0 ? (
        <span style={{ fontSize: 12.5, color: 'var(--ds-muted)', whiteSpace: 'nowrap' }}>
          Aggiungi qui le funzioni che usi di più con la ★ sulle card.
        </span>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {routes.map((to) => {
            const c = findCardByRoute(to);
            const Icon = c.icon;
            const color = c.macro?.color || 'var(--brand)';
            const active = pathname === to || (to !== '/' && pathname.startsWith(to + '/'));
            return (
              <button
                key={to}
                type="button"
                onClick={() => navigate(to)}
                aria-current={active ? 'page' : undefined}
                title={`Vai a ${c.label}`}
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: 7, padding: '7px 12px',
                  borderRadius: 'var(--radius-base)', border: '1px solid',
                  borderColor: active ? color : 'var(--ds-border)',
                  background: active ? 'var(--chip)' : 'var(--ds-bg)',
                  color: 'var(--ink)', fontSize: 12.5, fontWeight: 500, cursor: 'pointer',
                  whiteSpace: 'nowrap', flexShrink: 0,
                }}
                onMouseEnter={(e) => { if (!active) e.currentTarget.style.borderColor = 'var(--brand)'; }}
                onMouseLeave={(e) => { if (!active) e.currentTarget.style.borderColor = 'var(--ds-border)'; }}
              >
                <Icon size={15} strokeWidth={1.8} color={color} />
                {c.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
